export var BID_TEMPLATES = {
  selective_clearing: { name: 'Selective Tree Clearing', lines: [
    { description: 'Mobilization / Demobilization', category: 'mobilization', quantity: 1, unit: 'LS' },
    { description: 'Selective Tree Removal', category: 'tree_removal', quantity: 1, unit: 'LS' },
    { description: 'Stump Grinding', category: 'tree_removal', quantity: 1, unit: 'EA' },
    { description: 'Brush Clearing & Chipping', category: 'clearing', quantity: 1, unit: 'AC' },
    { description: 'Debris Hauling & Disposal', category: 'hauling', quantity: 1, unit: 'LD' },
    { description: 'Site Cleanup', category: 'other', quantity: 1, unit: 'LS' },
  ]},
  mass_clearing: { name: 'Mass Clearing / Grubbing', lines: [
    { description: 'Mobilization / Demobilization', category: 'mobilization', quantity: 1, unit: 'LS' },
    { description: 'Mass Clearing & Grubbing', category: 'clearing', quantity: 1, unit: 'AC' },
    { description: 'Tree Removal (>6 inch DBH)', category: 'tree_removal', quantity: 1, unit: 'AC' },
    { description: 'Stump Removal / Grinding', category: 'tree_removal', quantity: 1, unit: 'AC' },
    { description: 'Topsoil Strip & Stockpile', category: 'grading', quantity: 1, unit: 'CY' },
    { description: 'Debris Hauling & Disposal', category: 'hauling', quantity: 1, unit: 'LD' },
    { description: 'Erosion Control - Silt Fence', category: 'erosion_control', quantity: 1, unit: 'LF' },
    { description: 'Site Cleanup & Restoration', category: 'other', quantity: 1, unit: 'LS' },
  ]},
  full_site_work: { name: 'Full Site Work', lines: [
    { description: 'Mobilization / Demobilization', category: 'mobilization', quantity: 1, unit: 'LS' },
    { description: 'Clearing & Grubbing', category: 'clearing', quantity: 1, unit: 'AC' },
    { description: 'Tree Removal', category: 'tree_removal', quantity: 1, unit: 'AC' },
    { description: 'Stump Removal / Grinding', category: 'tree_removal', quantity: 1, unit: 'AC' },
    { description: 'Topsoil Strip & Stockpile', category: 'grading', quantity: 1, unit: 'CY' },
    { description: 'Mass / Rough Grading', category: 'grading', quantity: 1, unit: 'CY' },
    { description: 'Fine Grading', category: 'grading', quantity: 1, unit: 'SF' },
    { description: 'Erosion Control - Silt Fence', category: 'erosion_control', quantity: 1, unit: 'LF' },
    { description: 'Erosion Control - Inlet Protection', category: 'erosion_control', quantity: 1, unit: 'EA' },
    { description: 'Debris Hauling & Disposal', category: 'hauling', quantity: 1, unit: 'LD' },
    { description: 'Import Fill Material', category: 'grading', quantity: 1, unit: 'CY' },
    { description: 'Site Cleanup & Restoration', category: 'other', quantity: 1, unit: 'LS' },
  ]},
  demolition: { name: 'Demolition Only', lines: [
    { description: 'Mobilization / Demobilization', category: 'mobilization', quantity: 1, unit: 'LS' },
    { description: 'Structure Demolition', category: 'demolition', quantity: 1, unit: 'LS' },
    { description: 'Foundation Removal', category: 'demolition', quantity: 1, unit: 'CY' },
    { description: 'Pavement / Concrete Removal', category: 'demolition', quantity: 1, unit: 'SF' },
    { description: 'Utility Disconnect & Cap', category: 'demolition', quantity: 1, unit: 'LS' },
    { description: 'Debris Hauling & Disposal', category: 'hauling', quantity: 1, unit: 'LD' },
    { description: 'Backfill & Compaction', category: 'grading', quantity: 1, unit: 'CY' },
    { description: 'Site Cleanup', category: 'other', quantity: 1, unit: 'LS' },
  ]},
};
